<template>
	<div>
		<DomiciliationHeader />

		<b-container fluid>
			<b-row>
				<b-col cols="12" xl="8">
					<DomiciliationStepper />

					<DomiciliationFooter />
				</b-col>

				<b-col class="d-none d-xl-block p-3 bg-light sticky-top" align-self="baseline">
					<DomiciliationSummary
					:company="services.domiciliation.company"
					:domiciliation="services.domiciliation.domiciliation"
					:particulars="services.domiciliation.particulars"
					:mailOptions="services.domiciliation.mailOptions"
					:packs="services.creation.packs"
					:options="services.domiciliation.options"
					:price="services.domiciliation.price"
					/>
				</b-col>
			</b-row>
		</b-container>

		<DomiciliationHelpModal />
	</div>
</template>

<script>
	import { mapState } from 'vuex'

	import DomiciliationHeader from '../../components/domiciliation/DomiciliationHeader.vue'
	import DomiciliationStepper from '../../components/domiciliation/DomiciliationStepper.vue';
	import DomiciliationSummary from '../../components/domiciliation/DomiciliationSummary.vue';
	import DomiciliationHelpModal from '../../components/domiciliation/DomiciliationHelpModal.vue'
	import DomiciliationFooter from '../../components/domiciliation/DomiciliationFooter.vue'

	export default {
		components: {
			DomiciliationHeader,
			DomiciliationStepper,
			DomiciliationSummary,
			DomiciliationHelpModal,
			DomiciliationFooter
		},
		computed: {
			...mapState(['services'])
		}
	}
</script>
